import { Component, inject, Injector } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DialogService,
  DialogWidth,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';
import {
  canActivateDataSource,
  SimpleViewComponent,
  ViewsLocalStorageService,
} from '@core/views-legacy';
import { WrappedTableListGroupHeadingComponent } from '@core/views-ui';
import { dataSourceProviders, provideListLayout, provideViewBaseRoute } from '@core/views-util';

import { AskTemplatesDataSourceService } from './ask-templates-data-source.service';
import { AskFormListItemComponent } from './ask-templates-list-item/ask-form-list-item.component';
import { AddNewTemplateComponent } from '../add-new-template/add-new-template.component';
import { SetupBannerComponent } from '../setup-banner/setup-banner.component';

@Component({
  selector: 'tlc-asks-templates',
  template: `
    <div padding>
      <div layout layout-space-between layout-align-items-center>
        <div>
          <rt-heading variant="large heading"
            >{{ 'tlc.ask_hr.forms.heading' | translate }}
          </rt-heading>
          <p>
            {{ 'tlc.ask_hr.forms.subheading' | translate }}
          </p>
        </div>
        <rt-button (click)="onAddTemplate()" variant="primary">
          <rt-icon name="add" />
          {{ 'tlc.ask_hr.forms.add_new_form' | translate }}
        </rt-button>
      </div>
    </div>
    <rt-divider />
    @if (canActivate()) {
      <rt-simple-view
        viewId="ask_templates:all"
        [hasGroupsControl]="false"
        [selfScrollEnabled]="true"
        forcedLayout="list"
        class="view"
      >
        <ng-container banner>
          <ask-hr-setup-banner
            [canClose]="true"
            class="banner"
            margin-lr-auto
            margin-bottom-small
          />
        </ng-container>
      </rt-simple-view>
    }
  `,
  imports: [
    SimpleViewComponent,
    ButtonComponent,
    HeadingComponent,
    TranslatePipe,
    IconComponent,
    DividerComponent,
    SetupBannerComponent,
  ],
  providers: [
    ViewsLocalStorageService,
    provideViewBaseRoute('/asks/templates'),
    AskTemplatesDataSourceService,
    dataSourceProviders('ask_templates', {
      ask_templates: AskTemplatesDataSourceService,
    }),
    provideListLayout({
      ask_templates: {
        header: WrappedTableListGroupHeadingComponent,
        record: AskFormListItemComponent,
        recordSettings: {
          hasPadding: false,
        },
      },
    }),
  ],
  styleUrls: ['./ask-templates-view.component.less'],
})
export class TellentAskTemplatesViewComponent {
  private readonly dialogService = inject(DialogService);
  private readonly injector = inject(Injector);
  private readonly canActivateFn = canActivateDataSource();
  private readonly canActivate$ = this.canActivateFn();
  protected canActivate = toSignal(this.canActivate$);

  protected onAddTemplate() {
    this.dialogService.openDialog(AddNewTemplateComponent, undefined, {
      injector: this.injector,
      width: DialogWidth.LargeX,
    });
  }
}
